import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { DialogConfig } from './dialog-config';

export class DialogRef<T = any> {
  private afterClosedSubject = new Subject<T>();

  constructor(
    private overlayRef: OverlayRef,
    public config: DialogConfig,
  ) {
    if (!config.disableClose) {
      this.overlayRef.backdropClick().subscribe(() => {
        this.close();
      });

      this.overlayRef
        .keydownEvents()
        .pipe(filter((event) => event.key === 'Escape'))
        .subscribe(() => {
          this.close();
        });
    }
  }
  public disableClose(): void {
    this.config.disableClose = true;
  }

  public enableClose(): void {
    this.config.disableClose = false;
  }

  public updateSize(width?: string): void {
    this.overlayRef.updateSize({
      width: width || this.config.width,
    });
  }

  public close(dialogResult?: T): void {
    this.afterClosedSubject.next(dialogResult);
    this.afterClosedSubject.complete();

    this.overlayRef.dispose();
  }

  public afterClosed(): Observable<T> {
    return this.afterClosedSubject.asObservable();
  }
}
